'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const SearchBar = ({ searchQuery, onSearchChange }: SearchBarProps) => {
  const [localQuery, setLocalQuery] = useState(searchQuery);

  useEffect(() => {
    setLocalQuery(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearchChange(localQuery);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [localQuery, onSearchChange]);

  const handleClear = () => {
    setLocalQuery('');
    onSearchChange('');
  };

  return (
    <div data-component-id="src/app/projects-index/components/SearchBar.tsx:32:4" data-component-path="src/app/projects-index/components/SearchBar.tsx" data-component-line="32" data-component-end-line="52" data-component-file="SearchBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20flex-1%20max-w-md%22%7D" className="relative flex-1 max-w-md">
      <div data-component-id="src/app/projects-index/components/SearchBar.tsx:33:6" data-component-path="src/app/projects-index/components/SearchBar.tsx" data-component-line="33" data-component-end-line="35" data-component-file="SearchBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-4%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%20pointer-events-none%22%7D" className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
        <Icon data-component-id="src/app/projects-index/components/SearchBar.tsx:34:8" data-component-path="src/app/projects-index/components/SearchBar.tsx" data-component-line="34" data-component-end-line="34" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%7D" name="MagnifyingGlassIcon" size={20} />
      </div>
      <input data-component-id="src/app/projects-index/components/SearchBar.tsx:36:6" data-component-path="src/app/projects-index/components/SearchBar.tsx" data-component-line="36" data-component-end-line="42" data-component-file="SearchBar.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AlocalQuery%5D%22%2C%22className%22%3A%22w-full%20pl-12%20pr-12%20py-2.5%20rounded-lg%20border%20border-border%20bg-card%20text-foreground%20placeholder%3Atext-muted-foreground%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-primary%20transition-smooth%22%7D"
        type="text"
        value={localQuery}
        onChange={(e) => setLocalQuery(e.target.value)}
        placeholder="Search projects..."
        className="w-full pl-12 pr-12 py-2.5 rounded-lg border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-smooth"
      />
      {localQuery && (
        <button data-component-id="src/app/projects-index/components/SearchBar.tsx:44:8" data-component-path="src/app/projects-index/components/SearchBar.tsx" data-component-line="44" data-component-end-line="50" data-component-file="SearchBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-4%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%20hover%3Atext-foreground%20transition-smooth%22%7D"
          onClick={handleClear}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-smooth"
          aria-label="Clear search"
        >
          <Icon data-component-id="src/app/projects-index/components/SearchBar.tsx:49:10" data-component-path="src/app/projects-index/components/SearchBar.tsx" data-component-line="49" data-component-end-line="49" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={20} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;